import React from 'react'
import {motion} from 'framer-motion'
import {useState} from 'react'
import Amazon from '../img/amazon-logo.png'
import Whatsapp from '../img/Whatsapp.png'
import Meme from '../img/Meme.png'
import SOCIALcircle from '../img/SOCIALcircle.png'
import MusicPlayer from '../img/MusicPlayer.png'
import Netflix from '../img/netflix.png'
import Todo from '../img/todolist.png'
import airbnb from '../img/airbnb.png'
import Contact from '../img/Contact.png'
import Calculator from '../img/Calculator.png'
import Github from '../img/github.png'
import GitHubIcon from "@mui/icons-material/GitHub";

import{Swiper, SwiperSlide} from "swiper/react"
// import SwiperCore,{EffectCoverflow,Pagination} from "swiper/core"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import './Education.scss'
import SwiperCore,{EffectCoverflow,Pagination,Navigation} from "swiper/core"
import Tilt from 'react-parallax-tilt';




import Loader from 'react-loaders'
import ReactCardFlip from 'react-card-flip'
SwiperCore.use([EffectCoverflow,Pagination,Navigation])
function Portfolio() {
  



  const data=[
    {
        id:1,
        title:"Amazon Clone",
        description:"Amazon Clone built with full e commerce functionalities including a payment gateway excecuted by Stripe and the website was build using NextJS and tailwind css",
        image:Amazon,
        Github:"https://github.com/PrarthnaLuthra/Amazon-Clone"
        
    },
    {
        id:2,
        title:"Whatsapp Clone",
        description:"A complete MERN Stack build of the chat engine of Whatsapp web using fake api for profile pics which are changing in a random order",
        image:Whatsapp,
        Github:"https://github.com/PrarthnaLuthra/Whatsapp-clone-mern"

    },
    {
        id:3,
        title:"Netflix Clone",
        description:"Netflix Clone the frontend part of netflix was build using ReactJS with react-youtube, which plays youtube trailer",
        image:Netflix,
        Github:"https://github.com/PrarthnaLuthra/Netflix-Clone"


    },
    {
        id:4,
        title:"Airbnb Experiences Clone",
        description:"AirBnb Experiences Clone is a Static webpage developed using ReactJS as project to learn React",
        image:airbnb,
        Github:"https://github.com/PrarthnaLuthra/AirBnb-Experiences-Clone"
    },
    {
        id:5,
        title:"SOCIALcircle",
        description:"A Social media website build as a backend NodeJs project using NodeJs,ejs,SASS,CSS and mongoDB",
        image:SOCIALcircle,
        Github:"https://github.com/PrarthnaLuthra/SOCIALcircle"
    },
    {
        id:6,
        title:"Meme Generator",
        description:"Meme-generator was developed using ReactJS and API calls were done to generate a random meme",
        image:Meme,
        Github:"https://github.com/PrarthnaLuthra/Meme-Generator"
    },{
        id:7,
        title:"SingAlong",
        description:" Online Music Player website using plain  HTML, CSS and JavaScript built as a frontend project",
        image:MusicPlayer,
        Github:"https://github.com/PrarthnaLuthra/SingAlong"
    },{
        id:8,
        title:"TODOS app",
        description:"To-Do List developed as a back-end NodeJS project",
        image:Todo,
        Github:"https://github.com/PrarthnaLuthra/Todo-List-Node-js-project-"
    },{
        id:9,
        title:"Contact List",
        description:"Contact-List was developed using NodeJs, ejs,CSS and mongoDB as a backend project",
        image:Contact,
        Github:"https://github.com/PrarthnaLuthra/Contact-List"
    },{
        id:10,
        title:"Calculator-JS",
        description:"Calculator-JS was Developed using HTML,CSS and javascript as part of learning Javascript",
        image:Calculator,
        Github:"https://github.com/PrarthnaLuthra/Calculator-JS"
    }
    

]



  return (
    <>
    <div className='container'>
       <div className="textZone" >
         
         <h1 className='text-[#63e8ff] font-bold text-2xl md:text-2xl mb-5 opacity-75'>
           Projects
          </h1>
        
       
        
          

       </div>
      <div className='swiper-container'>
     <div className='flex justify-center'>
    
    <img src={Github} className="w-[15vw] h-[40vh] -m-5 mt-4"/>
    
     
    
    

      <Swiper
        
        effect={"coverflow"}
        centeredSlides={true}
        slidesPerView={window.innerWidth <768?1:"auto"}
        loop={true}
        coverflowEffect={{
            rotate:0,
            stretch:0,
            depth:100,
            modifier:4,
            slideShadows:true
        }}
        pagination={{
            clickable:true
        }} className="left-[10%]">
          <div className='flex'>
          {data.map((data, key) => (

          <SwiperSlide>
            <div className='flex  h-[390px] flex-col  justify-around w-auto  bg-cyan-900 bg-opacity-[0.97] rounded-md p-6 pt-8 relative z-1  border-transparent  cursor-pointer shadow-cyan-200 shadow-md mb-0'>
              <div className='flex items-center flex-col'>
              <div className='h-[120px] w-[120px] items-center flex justify-center' >
              <img src={data.image} className='w-[50px] h-[50px]'/>
              </div>
              <h1  className=' text-center mx-1 text-orange-200'>{data.title}</h1>
              <p className='text-sm text-center text-cyan-100 '>
                {data.description}
             </p>
             </div>
            <div className='flex justify-end items-end'>
            <a rel="noreferrer" href={data.Github} target="_blank"><GitHubIcon className=" github m-2 text-right text-[#b5ffff] hover:text-[#02adc0] hover:cursor-pointer scale-[0.7]"/></a>
            </div>
            </div>
            
            
    

          </SwiperSlide>
          
          ))}
          
          </div>



        </Swiper>

      
        
    </div>


    <Loader type='ball-scale-multiple'/>
    </div>
    </div>
    
    </>
  )
}

export default Portfolio